export default "__VITE_ASSET__BTY4ViPK__"